// @ts-ignore
import { AxiosResponse } from 'axios'
// @ts-ignore
import { NuxtAxiosInstance } from '@nuxtjs/axios'
import BaseRepository from '../BaseRepository'

export default class NavigationRepository extends BaseRepository {
  constructor(protected endpoint: string, $axios: NuxtAxiosInstance) {
    super(endpoint, $axios)
  }

  getMenuListByType(
    alias: string = 'main',
    Authorization = null,
    url: string = '/',
    ...types: Array<string>
  ): Promise<AxiosResponse> {
    return this.$axios.get(`${this.endpoint}/items`, {
      params: {
        alias,
        types,
        url
      },
      headers: {
        Authorization,
        common: { Authorization: null }
      },
      timeout: 1000 * 15
    })
  }
}
